import { z } from "zod";

// A cell the stop request reverted (or attempted to) — echoed back so callers
// can highlight the affected cells and report on what was skipped.
export const StoppedCellSchema = z.object({
  sourceRowId: z.string(),
  columnId: z.string(),
});
export type StoppedCell = z.infer<typeof StoppedCellSchema>;

// A cell the stop could not touch, and why. sourceRowId/columnId are nullable
// on the BE for skips that aren't tied to a specific cell (e.g. table-level).
export const SkippedCellSchema = z.object({
  sourceRowId: z.string().nullable(),
  columnId: z.string().nullable(),
  table: z.string(),
  reason: z.enum(["human", "locked"]),
});
export type SkippedCell = z.infer<typeof SkippedCellSchema>;

// Response from POST /controls/v2/event-run/{eventRunId}/stop
export const StopEventRunResponseSchema = z.object({
  eventRunId: z.string(),
  cancelledRunIds: z.array(z.string()),
  stoppedScope: z.array(StoppedCellSchema),
  skipped: z.array(SkippedCellSchema),
  alreadyFinished: z.boolean(),
});
export type StopEventRunResponse = z.infer<typeof StopEventRunResponseSchema>;
